// Platform constants with names, icons, and colors
// Instagram is first to make it the default selection
export const PLATFORMS = {
  instagram: {
    id: "instagram",
    name: "Reels",
    enabled: true,
    color: "#E4405F", // Instagram gradient pink/magenta
    icon: (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.665.014 15.257 0 12 0zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zM12 16c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
      </svg>
    ),
  },
  youtube: {
    id: "youtube",
    name: "Shorts",
    enabled: false,
    color: "#FF0000", // YouTube red
    icon: (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    ),
  },
  tiktok: {
    id: "tiktok",
    name: "TikTok",
    enabled: false,
    color: "#FF0050", // TikTok pink/magenta
    icon: (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7.41a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
      </svg>
    ),
  },
};

// Helper function to get platform by ID
export const getPlatform = (platformId) => {
  return PLATFORMS[platformId] || null;
};

// Helper function to get platform icon
export const getPlatformIcon = (platformId) => {
  const platform = getPlatform(platformId);
  return platform ? platform.icon : null;
};

// Helper function to get platform color
export const getPlatformColor = (platformId) => {
  const platform = getPlatform(platformId);
  return platform ? platform.color : null;
};

/** Public profile URL for a creator on the given platform (Instagram, YouTube, TikTok). */
export const getCreatorProfileUrl = (platform, platformId) => {
  if (!platform || !platformId) return null;
  const id = (platformId || "").trim();
  if (platform === "instagram") return `https://www.instagram.com/${id.replace(/^@/, "")}/`;
  if (platform === "youtube") {
    if (id.startsWith("UC") && id.length >= 22) return `https://www.youtube.com/channel/${id}`;
    return `https://www.youtube.com/${id.startsWith("@") ? id : `@${id}`}`;
  }
  if (platform === "tiktok") return `https://www.tiktok.com/@${id.replace(/^@/, "")}`;
  return null;
};

// Array of all platforms (useful for mapping)
export const PLATFORMS_ARRAY = Object.values(PLATFORMS);

